/**
 * Created by baiqi.li on 2018/9/4.
 */

import Logic from '@/logic/logic-base'
const resourceModelBiz = new Logic()

resourceModelBiz.deleteResource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.deleteResource,
    data: data
  })
}

resourceModelBiz.deleteProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.deleteProperty,
    data: data
  })
}

resourceModelBiz.getResource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.getResource,
    data: data
  })
}

resourceModelBiz.saveProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.saveProperty,
    data: data
  })
}

resourceModelBiz.saveResource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.saveResource,
    data: data
  })
}

resourceModelBiz.updateProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.updateProperty,
    data: data
  })
}

resourceModelBiz.updateResource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.updateResource,
    data: data
  })
}

resourceModelBiz.getProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.getProperty,
    data: data
  })
}

resourceModelBiz.getInstanceByTable = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resourceModel.getInstanceByTable,
    data: data
  })
}

export default resourceModelBiz
